// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"bc82d7bc","29":"c86fd1f6","120":"fbe0b4d5","134":"957ec39e","375":"cab76bb0","447":"cf841d1a","477":"0d1ed808","762":"e440da16","828":"42568f3a","969":"d603981a"}[chunkId] + ".chunk.js";
};